module.exports = __webpack_public_path__ + "images/line_gold_083ca8387e38290e6dc1ecd1cc54141a.jpg";